import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Badge } from 'primereact/badge';
import { Divider } from 'primereact/divider';

const AlertDetailModal = ({ visible, onHide, alertHistory }) => {
  if (!alertHistory) return null;

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    
    // Créer un objet Date à partir de la string UTC
    const date = new Date(dateString);
    
    // Utiliser les méthodes UTC pour préserver l'heure originale
    // au lieu de la convertir en heure locale
    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'UTC' // Forcer l'affichage en UTC
    };
    
    console.log('🕐 AlertDetailModal - Date originale:', dateString);
    console.log('🕐 AlertDetailModal - Date formatée UTC:', date.toLocaleDateString('fr-FR', options));
    
    return date.toLocaleDateString('fr-FR', options);
  };

  const calculateDuration = () => {
    if (!alertHistory.startDate || !alertHistory.endDate) return '-';
    
    const start = new Date(alertHistory.startDate);
    const end = new Date(alertHistory.endDate);
    const duration = end - start;
    
    const hours = Math.floor(duration / (1000 * 60 * 60));
    const minutes = Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60));
    
    if (hours > 0) {
      return `${hours}h ${minutes}min`;
    }
    return `${minutes}min`;
  };

  const getSensorTypeLabel = (sensorType) => {
    const types = {
      'temperature': 'Température',
      'humidity': 'Humidité',
      'door': 'Porte',
      'battery': 'Batterie',
      'rssi': 'Signal'
    };
    return types[sensorType] || sensorType;
  };

  const getStatusSeverity = (isEnd, isRead) => {
    if (isEnd && isRead) return 'success';
    if (isEnd && !isRead) return 'info';
    if (!isEnd && isRead) return 'warning';
    return 'danger';
  };

  const getStatusLabel = (isEnd, isRead) => {
    if (isEnd && isRead) return 'Terminé et Traité';
    if (isEnd && !isRead) return 'Terminé - Non Traité';
    if (!isEnd && isRead) return 'En Cours - Traité';
    return 'En Cours - Non Traité';
  };

  const footer = (
    <div className="flex justify-content-end">
      <Button 
        label="Fermer" 
        icon="pi pi-times" 
        onClick={onHide}
        className="p-button-outlined"
      />
    </div>
  );

  return (
    <Dialog
      header="Détails de l'Alerte"
      visible={visible}
      onHide={onHide}
      footer={footer}
      style={{ width: '700px', marginTop: '5vh' }}
      modal
      className="p-fluid"
      position="center"
    >
      <div className="flex flex-column gap-4">
        {/* En-tête avec code et statut */}
        <div className="flex justify-content-between align-items-center p-2 border-round surface-100">
          <div>
            <h3 className="m-0 text-primary">{alertHistory.alertCode}</h3>
            <p className="m-0 text-600 text-sm mt-1">ID: {alertHistory.uid}</p>
          </div>
          <Badge 
            value={getStatusLabel(alertHistory.isEnd, alertHistory.isRead)}
            severity={getStatusSeverity(alertHistory.isEnd, alertHistory.isRead)}
            className="text-sm"
          />
        </div>

        {/* Informations principales */}
        <div className="grid">
          <div className="col-12 md:col-6">
            <div className="field">
              <label className="font-semibold text-900">Type de Capteur</label>
              <div className="flex align-items-center gap-2 mt-1">
                <i className={`pi ${alertHistory.sensorType === 'temperature' ? 'pi-sun' : 
                  alertHistory.sensorType === 'humidity' ? 'pi-cloud' : 
                  alertHistory.sensorType === 'door' ? 'pi-home' : 'pi-circle'}`}></i>
                <span>{getSensorTypeLabel(alertHistory.sensorType)}</span>
              </div>
            </div>
          </div>
          
          <div className="col-12 md:col-6">
            <div className="field">
              <label className="font-semibold text-900">Condition Déclenchée</label>
              <div className="mt-1">
                <Badge value={alertHistory.condition} severity="warning" className="text-sm" />
              </div>
            </div>
          </div>

          {/* Informations sur qui a traité l'alerte */}
          {alertHistory.reader && alertHistory.isRead === 1 && (
            <div className="col-12 md:col-6">
              <div className="field">
                <label className="font-semibold text-900">Traité par</label>
                <div className="flex align-items-center gap-2 mt-1">
                  <i className="pi pi-check-circle text-green-500"></i>
                  <span className="text-green-600 font-medium">{alertHistory.reader}</span>
                  {alertHistory.readBy && (
                    <span className="text-400 text-sm">(ID: {alertHistory.readBy})</span>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* Affichage si l'alerte est lue mais pas encore traitée */}
          {alertHistory.isRead === 1 && !alertHistory.reader && (
            <div className="col-12 md:col-6">
              <div className="field">
                <label className="font-semibold text-900">Statut de traitement</label>
                <div className="flex align-items-center gap-2 mt-1">
                  <i className="pi pi-info-circle text-blue-500"></i>
                  <span className="text-blue-600 font-medium">Marqué comme lu</span>
                  {alertHistory.readBy && (
                    <span className="text-400 text-sm">(ID: {alertHistory.readBy})</span>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* <div className="col-12">
            <div className="field">
              <label className="font-semibold text-900">Capteur (MAC)</label>
              <div className="mt-1 font-mono text-sm">
                {alertHistory.macAddr}
              </div>
            </div>
          </div> */}
        </div>

        {/* <Divider /> */}

        {/* Message d'alerte */}
        <div className="field">
          <label className="font-semibold text-900">Message d'Alerte</label>
          <div className="mt-2 p-3 border-round surface-50 text-sm">
            {alertHistory.message}
          </div>
        </div>

        {/* <Divider /> */}

        {/* Informations temporelles */}
        <div className="grid">
          <div className="col-12 md:col-6">
            <div className="field">
              <label className="font-semibold text-900">Date de Début</label>
              <div className="mt-1 text-sm">
                <i className="pi pi-calendar mr-2 text-500"></i>
                {formatDate(alertHistory.startDate)}
              </div>
            </div>
          </div>

          <div className="col-12 md:col-6">
            <div className="field">
              <label className="font-semibold text-900">Date de Fin</label>
              <div className="mt-1 text-sm">
                <i className="pi pi-calendar mr-2 text-500"></i>
                {alertHistory.endDate ? formatDate(alertHistory.endDate) : 'En cours...'}
              </div>
            </div>
          </div>

          {/* <div className="col-12 md:col-6">
            <div className="field">
              <label className="font-semibold text-900">Durée</label>
              <div className="mt-1 text-sm">
                <i className="pi pi-clock mr-2 text-500"></i>
                {calculateDuration()}
              </div>
            </div>
          </div> */}

          {/* <div className="col-12 md:col-6">
            <div className="field">
              <label className="font-semibold text-900">Créé le</label>
              <div className="mt-1 text-sm">
                <i className="pi pi-plus-circle mr-2 text-500"></i>
                {formatDate(alertHistory.createAt)}
              </div>
            </div>
          </div> */}
        </div>

        {/* Section de traçabilité */}
        {(alertHistory.reader || alertHistory.isRead === 1) && (
          <>
            <Divider />
            <div className="field">
              <label className="font-semibold text-900">
                <i className="pi pi-shield mr-2 text-500"></i>
                Traçabilité de l'Intervention
              </label>
              <div className="mt-2 p-3 border-round surface-50">
                {alertHistory.reader && alertHistory.isRead === 1 ? (
                  <div className="flex align-items-center gap-3">
                    <div className="flex align-items-center gap-2">
                      <i className="pi pi-check-circle text-green-500 text-lg"></i>
                      <div>
                        <div className="font-medium text-green-700">Alerte traitée par</div>
                        <div className="text-green-600 font-semibold">{alertHistory.reader}</div>
                        {alertHistory.readBy && (
                          <div className="text-400 text-sm">ID utilisateur: {alertHistory.readBy}</div>
                        )}
                      </div>
                    </div>
                  </div>
                ) : alertHistory.isRead === 1 ? (
                  <div className="flex align-items-center gap-3">
                    <div className="flex align-items-center gap-2">
                      <i className="pi pi-info-circle text-blue-500 text-lg"></i>
                      <div>
                        <div className="font-medium text-blue-700">Alerte marquée comme lue</div>
                        {alertHistory.readBy && (
                          <div className="text-400 text-sm">ID utilisateur: {alertHistory.readBy}</div>
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="flex align-items-center gap-3">
                    <div className="flex align-items-center gap-2">
                      <i className="pi pi-exclamation-triangle text-orange-500 text-lg"></i>
                      <div>
                        <div className="font-medium text-orange-700">Alerte non traitée</div>
                        <div className="text-orange-600">En attente d'intervention</div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </>
        )}

        {/* Historique des commentaires/interventions */}
        {(() => {
          // Parser le JSON des commentaires
          let parsedComments = [];
          try {
            if (alertHistory.comments && typeof alertHistory.comments === 'string') {
              parsedComments = JSON.parse(alertHistory.comments);
            } else if (Array.isArray(alertHistory.comments)) {
              parsedComments = alertHistory.comments;
            }
          } catch (error) {
            console.error('Erreur lors du parsing des commentaires:', error);
            parsedComments = [];
          }
          
          // Afficher la section des commentaires
          if (parsedComments && parsedComments.length > 0) {
            // Afficher l'historique des interventions (comments JSON)
            return (
              <>
                {/* <Divider /> */}
                <div className="field">
                  <label className="font-semibold text-900">
                    <i className="pi pi-comments mr-2 text-500"></i>
                    Historique des Interventions ({parsedComments.length})
                  </label>
                  <div className="mt-2 p-3 border-round surface-50 max-h-20rem overflow-y-auto">
                    {parsedComments.map((commentItem, index) => {
                      const hasUserInfo = commentItem.user || commentItem.userId;
                      return (
                        <div key={commentItem.id || index} className={`mb-3 p-3 border-round border-1 ${hasUserInfo ? 'surface-0 border-primary-200' : 'surface-100 border-300'}`}>
                          <div className="flex justify-content-between align-items-start mb-2">
                            <div className="flex flex-column gap-1">
                              <span className="text-sm text-500 font-medium">
                                <i className="pi pi-calendar mr-1"></i>
                                {commentItem.date ? new Date(commentItem.date).toLocaleString('fr-FR') : 'Date non disponible'}
                              </span>
                              {/* Affichage des informations utilisateur */}
                              {hasUserInfo ? (
                                <div className="flex align-items-center gap-2 text-xs">
                                  <i className="pi pi-user text-primary"></i>
                                  <span className="text-primary font-medium">
                                    {commentItem.user || `Utilisateur ID: ${commentItem.userId}`}
                                  </span>
                                  {commentItem.userId && commentItem.user && (
                                    <span className="text-400">
                                      (ID: {commentItem.userId})
                                    </span>
                                  )}
                                </div>
                              ) : (
                                <div className="flex align-items-center gap-2 text-xs">
                                  <i className="pi pi-exclamation-triangle text-orange-500"></i>
                                  <span className="text-orange-600 font-medium">
                                    Utilisateur non identifié
                                  </span>
                                </div>
                              )}
                            </div>
                            {commentItem.id && (
                              <span className="text-xs text-400 font-medium">
                                ID: {commentItem.id}
                              </span>
                            )}
                          </div>
                          <p className="m-0 text-900 line-height-3">
                            <i className="pi pi-comment mr-2 text-600"></i>
                            {commentItem.message || commentItem.comment || commentItem.text || 'Commentaire vide'}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                  
                  {/* Afficher aussi le commentaire simple s'il existe */}
                  {alertHistory.comment && (
                    <div className="mt-3 p-3 border-round surface-100">
                      <label className="font-semibold text-900 block mb-2">
                        <i className="pi pi-comment mr-2 text-500"></i>
                        Dernier Commentaire
                      </label>
                      <p className="m-0 text-900">{alertHistory.comment}</p>
                    </div>
                  )}
                </div>
              </>
            );
          } else if (alertHistory.comment) {
            // Afficher seulement le commentaire simple s'il n'y a pas d'historique
            return (
              <>
                {/* <Divider /> */}
                <div className="field">
                  <label className="font-semibold text-900">
                    <i className="pi pi-comment mr-2 text-500"></i>
                    Commentaire d'Intervention
                  </label>
                  <div className="mt-2 p-3 border-round surface-50 text-sm">
                    {alertHistory.comment}
                  </div>
                </div>
              </>
            );
          } else {
            // Aucun commentaire disponible
            return null; // Ne rien afficher si pas de commentaires
          }
        })()}
      </div>
    </Dialog>
  );
};

export default AlertDetailModal;
